import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useParamsContext } from './ParamsProvider';
import { useNavigate } from 'react-router-dom';
export const ListContext = createContext();
export function useListContext() {
    return useContext(ListContext)
}
const restore_page_key = 'restore_page'
function storePage(page, limit) {
    localStorage.setItem(restore_page_key, JSON.stringify({ page, limit }))
}
function restorePage() {
    let { page, limit } = JSON.parse(localStorage.getItem(restore_page_key) || `{ "page": 1, "limit": 10 }`);
    localStorage.removeItem(restore_page_key)
    return { restored_page: page, restored_limit: limit }
}
export function useReloadPreservingListPage() {
    const { page, limit } = useListContext() || {};
    const navigate = useNavigate();
    let reload = useCallback(() => {
        if(page && limit){
            storePage(page, limit)
        }
        navigate(0);
    }, [navigate, page, limit])
    return reload;
}

export function ListProvider({ children, default_filter, default_sort, default_order = false, name, extra, restore_page_key }) {
    let { restored_page, restored_limit } = restorePage();
    const { flushParams } = useParamsContext();
    const [error, setError] = useState("")
    const [data, setData] = useState([]);
    const [page, setPage] = useState(restored_page);
    const [total_pages, setTotalPages] = useState(0);
    const [cnt, setCnt] = useState(0);
    const [sort, setSort] = useState(default_sort || 'id');
    const [order, setOrder] = useState(default_order);
    const [filter, setFilter] = useState(default_filter || {});
    const [loading, setLoading] = useState(false);
    const [totals, setTotals] = useState(undefined);
    const [limit, setLimit] = useState(restored_limit);
    const [tableInfo, setTableInfo] = useState(null);
    useEffect(() => {
        if (data.length == 0 && total_pages > 0 && total_pages < page) {
            setPage(total_pages);
        }
    }, [data, total_pages, page])
    return (
        <ListContext.Provider value={{
            // force_update, forceUpdate,
            data, setData,
            page, setPage,
            total_pages, setTotalPages,
            cnt, setCnt,
            sort, setSort,
            order, setOrder,
            filter, setFilter,
            loading, setLoading,
            error, setError,
            totals, setTotals,
            limit, setLimit,
            tableInfo, setTableInfo,
            extra,
            restore_page_key
        }}>
            {children}
        </ListContext.Provider>
    );
}